import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import pdfIcon from '../../../../assets/images/pdfIcon.png';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 50,
    padding: 15,
    marginBottom: 20,
    background: 'rgba(255,2555,255,0.5)',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  docName: {
    marginLeft: 20,
    fontSize: 16
  }
}));

const DocComponent = ({ docName, fullWidth, click }) => {
  const classes = useStyles();
  return (
    <Paper
      className={classes.root}
      elevation={1}
      onClick={click}
      style={{ width: fullWidth ? '100%' : 300 }}>
      <img alt="pdf-icon" height="100%" src={pdfIcon} />
      <h5 className={classes.docName}>{docName}</h5>
    </Paper>
  );
};

export default DocComponent;
